import {useEffect, useRef} from 'react';
import {useLocation} from 'react-router-dom';

/**
 *
 * @param scrollOnHash Complete hash string including the hash character.
 * @returns
 */
export default function useScrollToRefOnLocationHash<T extends HTMLElement>(
  scrollOnHash: string,
): React.MutableRefObject<T | null> {
  const result = useRef<T | null>(null);
  const {hash} = useLocation();

  useEffect(() => {
    if (hash === '#' + encodeURIComponent(scrollOnHash.substring(1))) {
      result.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
      });
    }
  }, [hash, scrollOnHash]);

  return result;
}
